import { DialogBody } from "@blueprintjs/core";
import styles from './wrapup.module.css';
import { useWrapup } from "../wrapupcontext";
import WrapupModuleAvatar from "./avatar";

export default function WrapupModuleWelcomeComponent(): React.ReactNode {
    const { wrapupData } = useWrapup();

    return <DialogBody className={styles.dialogBody}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <h1>Welcome to SPQR Wrapup 2025!</h1>
            <WrapupModuleAvatar user={wrapupData.user} />
            <h3>
                You played a lot of games, destroyed a lot of foes, and conquered many territories!
                Let&apos;s take a look at how you did across 2025.
            </h3>
        </div>
    </DialogBody>
}
